import { Box } from '@mui/material';

export const HouseKeeping = () => {
    return <Box sx={{ flex: 1 }}></Box>;
};
